import { useRef } from "react";

/*
  Die drei Reiter über dem Inhalt.

  Sie ersetzen das frühere Durchklicken: Vorlage, Notizen und Meinungsbild
  liegen nebeneinander statt hintereinander. Wer die Vorlage gelesen hat, gibt
  sein Meinungsbild mit einem Fingertipp ab — nicht mit Zurück, Zurück, Weiter.

  Gebaut nach dem Muster, das Bildschirmleser für Reiter erwarten (tablist /
  tab / tabpanel). Die Pfeiltasten wandern zwischen den Reitern, damit die
  Anwendung auch ohne Maus und ohne Finger bedienbar bleibt.

  Die Zahl am Reiter — etwa „Notizen 7“ — steht bewusst dabei: Sonst müsste
  man hineinschauen, um zu sehen, ob es dort etwas Neues gibt.
*/

export default function Reiter({ reiter, aktiv, aufWechsel }) {
  const knoepfe = useRef([]);

  function beiTaste(e) {
    const richtung = e.key === "ArrowRight" ? 1 : e.key === "ArrowLeft" ? -1 : 0;
    if (!richtung) return;
    e.preventDefault();

    const jetzt = reiter.findIndex((r) => r.schluessel === aktiv);
    const naechster = (jetzt + richtung + reiter.length) % reiter.length;
    aufWechsel(reiter[naechster].schluessel);
    if (knoepfe.current[naechster]) knoepfe.current[naechster].focus();
  }

  return (
    <div className="reiter" role="tablist" aria-label="Ansicht des Tagesordnungspunkts">
      {reiter.map((r, i) => (
        <button
          key={r.schluessel}
          ref={(el) => (knoepfe.current[i] = el)}
          className="reiter__knopf"
          role="tab"
          id={`reiter-${r.schluessel}`}
          aria-selected={aktiv === r.schluessel}
          aria-controls={`tafel-${r.schluessel}`}
          tabIndex={aktiv === r.schluessel ? 0 : -1}
          onClick={() => aufWechsel(r.schluessel)}
          onKeyDown={beiTaste}
        >
          {r.symbol && <r.symbol groesse={18} />}
          <span>{r.titel}</span>
          {r.anzahl > 0 && <span className="reiter__anzahl">{r.anzahl}</span>}
        </button>
      ))}
    </div>
  );
}

export function Tafel({ schluessel, aktiv, children }) {
  if (schluessel !== aktiv) return null;

  return (
    <div
      className="tafel"
      role="tabpanel"
      id={`tafel-${schluessel}`}
      aria-labelledby={`reiter-${schluessel}`}
      tabIndex={-1}
    >
      {children}
    </div>
  );
}
